import AuerUserListState from "@auer-steel/Store/Pages/UserList/AuerUserListState";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { Draft } from "immer";

const initialState: AuerUserListState = {   
    showDeactivated: false,
};

const reducer = {
    "Pages/AuerUserList/ToggleShowDeactivated": (draft: Draft<AuerUserListState>) => {
        draft.showDeactivated = !draft.showDeactivated;
    },    
};

export default createTypedReducerWithImmer(initialState, reducer);
